(() => {
  if (customElements.get('product-list-premium')) return;

  class ProductListPremium extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-product-viewport]');
      this.previousButton = this.querySelector('[data-product-prev]');
      this.nextButton = this.querySelector('[data-product-next]');

      if (!this.viewport || (!this.previousButton && !this.nextButton)) return;

      this.onPreviousClick = () => this.scrollByPage(-1);
      this.onNextClick = () => this.scrollByPage(1);
      this.onScroll = () => this.queueUpdate();

      this.previousButton?.addEventListener('click', this.onPreviousClick);
      this.nextButton?.addEventListener('click', this.onNextClick);
      this.viewport.addEventListener('scroll', this.onScroll, { passive: true });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.queueUpdate());
        this.resizeObserver.observe(this.viewport);
      } else {
        this.onWindowResize = () => this.queueUpdate();
        window.addEventListener('resize', this.onWindowResize, { passive: true });
      }

      this.queueUpdate();
    }

    disconnectedCallback() {
      this.previousButton?.removeEventListener('click', this.onPreviousClick);
      this.nextButton?.removeEventListener('click', this.onNextClick);
      this.viewport?.removeEventListener('scroll', this.onScroll);
      this.resizeObserver?.disconnect();
      if (this.onWindowResize) window.removeEventListener('resize', this.onWindowResize);
      if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
    }

    scrollByPage(direction) {
      const amount = Math.max(this.viewport.clientWidth * 0.82, 260);
      this.viewport.scrollBy({
        left: direction * amount,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    }

    queueUpdate() {
      if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
      this.updateFrame = requestAnimationFrame(() => this.updateButtons());
    }

    updateButtons() {
      const maxScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      const currentScroll = Math.max(0, this.viewport.scrollLeft);
      const canScroll = maxScroll > 4;

      if (this.previousButton) {
        this.previousButton.hidden = !canScroll;
        this.previousButton.disabled = !canScroll || currentScroll <= 4;
      }

      if (this.nextButton) {
        this.nextButton.hidden = !canScroll;
        this.nextButton.disabled = !canScroll || currentScroll >= maxScroll - 4;
      }
    }
  }

  customElements.define('product-list-premium', ProductListPremium);
})();
